import { objectToCamelCase, objectToSnakeCase } from '../utils'
import api from './api'

export default class Document {
  static api = api.create(Document)
  static readOnlyFields = ['id', 'docType']
  constructor(doc) {
    const { id = '', docType = '', event = null, expense = null, stipend = null, file = null, filename = '' } = doc
    Object.assign(this, {
      id,
      docType,
      event,
      expense,
      stipend,
      file,
      filename,
    })
  }

  static create(opts) {
    return new Document(opts)
  }
  static fromAPI(json = {}) {
    return new Document(objectToCamelCase(json))
  }
  /**
   * Prep data for the API. Can elect to include or exlude specific fields.
   * The `eadOnlyFields` are always excluded.
   **/
  static toAPI(doc, fields = [], excludeFields = []) {
    // By default, send the whole object
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = doc[field]
      })
    } else {
      data = doc
    }

    excludeFields = [...Document.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }
  static checkIsInstance(obj, name) {
    if (!(obj instanceof Document)) {
      throw Error(`${name} must be an instance of the Document class.`)
    }
  }

  /**
   * Generate a random, unique key for this document, to provide as a key
   * for Vue's `v-for`
   **/
  get key() {
    if (!this._key) {
      // Generate a random
      this._key = Math.random()
        .toString(36)
        .substring(2)
    }
    return this._key
  }
}
